import { endOfDay, startOfDay } from 'date-fns'
import moment, { Moment } from 'moment'
import 'moment/locale/pl'
import React, { useMemo } from 'react'
import DayPickerSingleDateController from 'react-dates/lib/components/DayPickerSingleDateController'
import {
  HORIZONTAL_ORIENTATION,
  VERTICAL_ORIENTATION,
} from 'react-dates/lib/constants'
import { is } from '../../MediaQuery'
import { isSameDate } from '../../../utils/Date'
import phrases from './phrases'

function DatePickerWidget({
  date,
  setDate,
  onDateChange,
  isAllowedDay,
  minDate,
  maxDate,
}: IDatePickerWidgetProps) {
  const momentLocale = moment.locale()
  const isMobile = is.mobile()
  const normalizedMinDate = useMemo(
    () => (minDate ? startOfDay(minDate) : null),
    [minDate],
  )
  const normalizedMaxDate = useMemo(
    () => (maxDate ? endOfDay(maxDate) : null),
    [maxDate],
  )

  const initialMonth = () => moment(date)
  const isDayHighlighted = (day: Moment) => isSameDate(new Date(), day.toDate())

  const handleDateChange = selectedDate => {
    const jsDate = startOfDay(selectedDate.toDate())
    setDate(jsDate)
    !isMobile && onDateChange(jsDate)
  }

  const isOutsideRange = (date: Moment) => {
    let jsDate = null
    if (minDate || maxDate || isAllowedDay) {
      jsDate = date.toDate()
    }
    if (
      (minDate && jsDate < normalizedMinDate) ||
      (maxDate && jsDate > normalizedMaxDate)
    ) {
      return true
    } else if (isAllowedDay) {
      return !isAllowedDay(jsDate)
    }

    return false
  }

  return (
    <>
      <div style={{ position: 'relative' }}>
        <DayPickerSingleDateController
          date={moment(date)}
          onDateChange={handleDateChange}
          focused={true}
          withPortal={isMobile}
          orientation={isMobile ? VERTICAL_ORIENTATION : HORIZONTAL_ORIENTATION}
          isOutsideRange={isOutsideRange}
          numberOfMonths={isMobile ? 1 : 2}
          initialVisibleMonth={initialMonth}
          isDayHighlighted={isDayHighlighted}
          phrases={phrases}
          hideKeyboardShortcutsPanel={true}
          weekDayFormat={['pt', 'pt-br'].includes(momentLocale) ? 'ddd' : 'dd'} //Three letter codes look better
          noBorder={isMobile}
          daySize={isMobile ? 35 : 39}
          minDate={minDate ? moment(minDate) : null}
          maxDate={maxDate ? moment(maxDate) : null}
        />
      </div>
    </>
  )
}

export default DatePickerWidget

export interface IDatePickerWidgetProps {
  date?: Date
  setDate?: (date: Date) => void
  onDateChange?: (date?: Date) => void
  isAllowedDay?: (date: Date) => boolean
  minDate?: Date
  maxDate?: Date
}
